const WebGLRenderer = {
  schema: {
    format: { type: 'Options', defaultValue: 'jpeg', values: ['jpeg', 'png'], labels: ['JPEG', 'PNG'], label: 'Output Format' },
    v2renderer: { type: 'Boolean', defaultValue: false, label: 'v2 renderer' },
  },
};

export default { WebGLRenderer };



// WEBPACK FOOTER //
// ./src/operators/Renderer.js